import { render, staticRenderFns } from "./SuggestionComments.vue?vue&type=template&id=da01e4fa&scoped=true"
import script from "./SuggestionComments.vue?vue&type=script&lang=js"
export * from "./SuggestionComments.vue?vue&type=script&lang=js"
import style0 from "./SuggestionComments.vue?vue&type=style&index=0&id=da01e4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da01e4fa",
  null
  
)

export default component.exports